import { RefreshCw } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui';
import { useNewBuild } from '@/lib/newBuild';

/**
 * Tells a tab running an older build that a new one is deployed. It stays until the reviewer reloads
 * or chooses Later, so it never interrupts work in progress; Later hides it until the next deploy.
 */
export const NewBuildNotice = () => {
  const deployed = useNewBuild();
  const [dismissed, setDismissed] = useState<string | null>(null);

  if (!deployed || dismissed === deployed) {
    return null;
  }
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-tooltip flex justify-center px-4">
      <div
        role="status"
        className="pointer-events-auto flex max-w-xl flex-wrap items-center gap-3 rounded-auditor bg-ink px-4 py-2 text-sm text-ink-inverse shadow-auditor-overlay"
      >
        <span className="flex-1 py-1">A new version of Food Auditor is available.</span>
        <Button size="small" startIcon={<RefreshCw className="size-4" />} onClick={() => window.location.reload()}>
          Reload
        </Button>
        <Button
          size="small"
          variant="ghost"
          className="text-ink-inverse hover:bg-ink-inverse/10"
          onClick={() => setDismissed(deployed)}
        >
          Later
        </Button>
      </div>
    </div>
  );
};
